import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showPopupNew } from '../../../../../actions/popup-actions';
import { PopupTypes } from '../../../../../utils/constants';
import { PowerFunnelGatedFeatures, PowerFunnelSurfaces } from '../../../../Analytics/constants';
import Img from '../../../../Img';
import styles from '../../collegeProspectTab.scss';

const SUBSCRIPTION_TIER_YEAR = 'year';
const TESTID_PREFIX = 'profile.college-prospect.upgrade-banner';

export const CPP_UPGRADE_SUBTITLE = 'Unlock the tools and insights you need to take control of your college recruiting journey!';

export const CPP_UPGRADE_FEATURES = [
    {
        key: 'college-fit-tool',
        iconSrc: '/img/v2/icons/icon-grad-hat.png',
        title: 'College Fit Tool',
        description: 'Get recommendations for colleges that are a best fit for you based on your UTR Rating.',
    },
    {
        key: 'custom-target-list',
        iconSrc: '/img/v2/icons/icon-clipboard.png',
        title: 'Custom College Target List',
        description: 'Create and manage your college list and notify coaches of your interest.',
    },
    {
        key: 'connect-with-coaches',
        iconSrc: '/img/v2/icons/icon-chat-bubble.png',
        title: 'Connect with College Coaches',
        description: 'See which coaches view your profile and message directly with schools you’re targeting.',
    },
];

const UpgradeToAnnualBanner = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth?.user);
    const isPowered = !!user?.isPowered;
    const isAnnual = user?.subscriptionTierType === SUBSCRIPTION_TIER_YEAR;

    if (isPowered && isAnnual) {
        return null;
    }

    const handleUpgradeClick = () => {
        const popup = isPowered
            ? PopupTypes.POWER_MONTHLY_UPGRADE_POPUP
            : PopupTypes.UPGRADE_TO_POWER_POPUP;
        dispatch(showPopupNew({
            popup,
            referringSurface: PowerFunnelSurfaces.PLAYER_PROFILE_COLLEGE_PROSPECT,
            gatedFeature: PowerFunnelGatedFeatures.COLLEGE_PROSPECT_TARGET_LIST,
        }));
    };

    return (
        <div
            className={styles.upgradeBanner}
            data-testid={`${TESTID_PREFIX}.container`}
        >
            <div
                className={styles.upgradeBannerHeader}
                data-testid={`${TESTID_PREFIX}.header`}
            >
                Upgrade to Annual Power
            </div>
            <div
                className={styles.upgradeBannerBody}
                data-testid={`${TESTID_PREFIX}.body`}
            >
                <div
                    className={styles.upgradeBannerSubtitle}
                    data-testid={`${TESTID_PREFIX}.subtitle`}
                >
                    {CPP_UPGRADE_SUBTITLE}
                </div>
                <div
                    className={styles.upgradeBannerFeatures}
                    data-testid={`${TESTID_PREFIX}.features`}
                >
                    {CPP_UPGRADE_FEATURES.map((feature) => (
                        <div
                            key={feature.key}
                            className={styles.upgradeBannerFeature}
                            data-testid={`${TESTID_PREFIX}.features.${feature.key}`}
                        >
                            <Img
                                src={feature.iconSrc}
                                alt={feature.title}
                                className={styles.upgradeBannerFeatureIcon}
                            />
                            <div className={styles.upgradeBannerFeatureText}>
                                <div
                                    className={styles.upgradeBannerFeatureTitle}
                                    data-testid={`${TESTID_PREFIX}.features.${feature.key}.title`}
                                >
                                    {feature.title}
                                </div>
                                <div
                                    className={styles.upgradeBannerFeatureDescription}
                                    data-testid={`${TESTID_PREFIX}.features.${feature.key}.description`}
                                >
                                    {feature.description}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={styles.upgradeBannerCta}>
                    <button
                        type="button"
                        className={styles.upgradeBannerCtaButton}
                        onClick={handleUpgradeClick}
                        data-testid={`${TESTID_PREFIX}.cta-btn`}
                    >
                        UPGRADE TO ANNUAL
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeToAnnualBanner;
